import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Input, DatePicker, Button, Select } from 'antd';

import { estacioIntroduccioIncidenciesAfegirIncidencia } from '../../actions/estacio';
import { selectorTipusIncidenciesEnFormatArray } from '../../selectors/selector_estacio_formulari_estructura';
import { MASCARA_DDMMYYYY, convertirTextAMomentUTC, esDataIniciPeriodeDeshabilitat, esDataFiPeriodeDeshabilitat } from '../../commons/gestioDates';
import PopoverError from '../commons/popoverError';

const { TextArea } = Input;
const { Option } = Select;

class EstacioInstroduccioIncidenciesAfegir extends Component {

    constructor(props) {
        super(props);

        this.initialState = {
            incidencia: {},
            errors: {
                dataInici: false,
                idTipusIncidencia: false
            }
        };
        //Inicialitzar amb l'objecte incidencia
        this.state = this.initialState;

        this.onChangeTipus = this.onChangeTipus.bind(this);
        this.onModificarDataInici = this.onModificarDataInici.bind(this);
        this.onModificarDataFi = this.onModificarDataFi.bind(this);
        this.deshabilitarDataFi = this.deshabilitarDataFi.bind(this);
        this.deshabilitarDataInici = this.deshabilitarDataInici.bind(this);
        this.onChangeDescripcio = this.onChangeDescripcio.bind(this);
    }

    /**
     * Si els camps obligatoris estan informats crida la acció per afegir una nova incidencia al store.
     * CAmps obligatoris: data inici i idTipusIncidencia
     */
    afegirIncidencia() {
        let conteErrors = false;    //Al ser asincron el setState() s'ha d'utilitzar un flag
        const { dataInici, idTipusIncidencia } = this.state.incidencia;

        //Validacio tipus incidencia
        if (typeof idTipusIncidencia === 'undefined' || idTipusIncidencia === null) {
            this.setState((prevState) => (
                {
                    errors: {
                        ...prevState.errors,
                        idTipusIncidencia: true
                    }
                }
            ));

            conteErrors = true;
        }

        //Validacio data inici
        if (typeof dataInici === 'undefined' || dataInici === null) {
            this.setState((prevState) => (
                {
                    errors: {
                        ...prevState.errors,
                        dataInici: true
                    }
                }
            ));

            conteErrors = true;
        }

        if (conteErrors) return;

        this.props.estacioIntroduccioIncidenciesAfegirIncidencia(this.state.incidencia);

        this.setState(() => this.initialState);
    }

    deshabilitarDataInici(dataCalendari) {
        const dataActual = convertirTextAMomentUTC(this.props.dataActualText);
        return esDataIniciPeriodeDeshabilitat(dataCalendari, dataActual, this.state.incidencia.dataFi, 'days');
    }

    deshabilitarDataFi(dataCalendari) {
        const dataActual = convertirTextAMomentUTC(this.props.dataActualText);
        return esDataFiPeriodeDeshabilitat(dataCalendari, dataActual, this.state.incidencia.dataInici, 'days');
    }

    onChangeDescripcio(event) {
        const text = event.target.value;
        this.setState((prevState) => (
            {
                incidencia: {
                    ...prevState.incidencia,
                    descripcio: text
                },
                errors: {
                    ...prevState.errors,
                }
            })
        );
    }

    onChangeTipus(idTipusIncidencia) {
        this.setState((prevState) => (
            {
                incidencia: {
                    ...prevState.incidencia,
                    idTipusIncidencia,
                },
                errors: {
                    ...prevState.errors,
                    idTipusIncidencia: false
                }
            })
        );
    }

    onModificarDataInici(dataInici) {
        if (dataInici && typeof dataInici !== 'undefined') {
            dataInici.startOf('day');
        }

        this.setState((prevState) => (
            {
                incidencia: {
                    ...prevState.incidencia,
                    dataInici
                },
                errors: {
                    ...prevState.errors,
                    dataInici: false
                }
            })
        );
    }

    onModificarDataFi(dataFi) {
        if (dataFi & typeof dataFi !== 'undefined') {
            dataFi.startOf('day');
        }

        this.setState((prevState) => (
            {
                ...prevState.errors,
                incidencia: {
                    ...prevState.incidencia,
                    dataFi
                }
            })
        );
    }

    renderOpcionsTipusIncidencies(tipusIncidencies) {
        return tipusIncidencies.map(incidencia => {
            const { id, nom } = incidencia;
            return <Option key={id} value={id}>{nom}</Option>;
        });
    }

    /**
     * Renderitza un error en cas que el parametre especificat sigui true
     * @param {*} param
     */
    renderError(param) {
        return (param) ?
            <PopoverError contingut='Camp obligatori' classNameIcona='icona-error' /> :
            null;
    }

    renderDatePicker(extraProps) {
        return <DatePicker
            format={MASCARA_DDMMYYYY}
            className='datepicker'
            {...extraProps}
        />;
    }

    render() {
        const { tipusIncidencies } = this.props;
        const { incidencia, errors } = this.state;

        const mostrarErrorTipusIncidencia = this.renderError(errors.idTipusIncidencia);
        const mostrarErrorDataInici = this.renderError(errors.dataInici);

        const propsDataInici = {
            placeholder: 'Data inici',
            onChange: this.onModificarDataInici,
            disabledDate: this.deshabilitarDataInici,
            value: incidencia.dataInici
        };
        const propsDataFi = {
            placeholder: 'Data fi',
            onChange: this.onModificarDataFi,
            disabledDate: this.deshabilitarDataFi,
            value: incidencia.dataFi
        };

        const idTipusIncidenciaSeleccionada = incidencia.idTipusIncidencia;

        return (
            <div className='estacio-introduccio-incidencies-afegir'>
                <div>
                    <Select
                        placeholder='Selecciona un tipus'
                        className='selector'
                        allowClear
                        showSearch
                        optionFilterProp='children'
                        onChange={(value) => this.onChangeTipus(value)}
                        value={idTipusIncidenciaSeleccionada}
                    >
                        {this.renderOpcionsTipusIncidencies(tipusIncidencies)}
                    </Select>
                    {mostrarErrorTipusIncidencia}
                </div>
                <div>
                    {this.renderDatePicker(propsDataInici)}
                    {mostrarErrorDataInici}
                </div>
                <div>
                    {this.renderDatePicker(propsDataFi)}
                </div>
                <div className='descripcio'>
                    <TextArea
                        placeholder='Descripció'
                        className='descripcio'
                        autosize={{ minRows: 1, maxRows: 4 }}
                        onChange={this.onChangeDescripcio}
                        value={incidencia.descripcio}
                    />
                </div>
                <Button type='primary'
                    icon='plus'
                    shape='circle'
                    onClick={() => this.afegirIncidencia()}
                />
            </div>

        );
    }
}

EstacioInstroduccioIncidenciesAfegir.propTypes = {
    dataActualText: PropTypes.string.isRequired,
    tipusIncidencies: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        nom: PropTypes.string
    })),
    estacioIntroduccioIncidenciesAfegirIncidencia: PropTypes.func
};

const mapDispatchToProps = {
    estacioIntroduccioIncidenciesAfegirIncidencia
};

const mapStateToProps = (state) => {
    return {
        tipusIncidencies: selectorTipusIncidenciesEnFormatArray(state)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EstacioInstroduccioIncidenciesAfegir);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioIncidenciesAfegir.js